// @ts-nocheck
import { getCatalogsList, GetProductCatalogsApiParameter } from "@store/Framework/Services/StoreAccountService";
import { ProductCatalogModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetProductCatalogsApiParameter, ProductCatalogModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadProductCatalogs: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/ProductCatalogs/BeginLoadProductCatalogs",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCatalogsList();
    } catch (error) {
        return false;
    }
};

export const DispatchCompleteLoadProductCatalogs: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/ProductCatalogs/CompleteLoadProductCatalogs",
        result: props.apiResult,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadProductCatalogs,
    RequestDataFromApi,
    DispatchCompleteLoadProductCatalogs,
];

const loadProductCatalogs = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadProductCatalogs");
export default loadProductCatalogs;
